import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Colton Wiscombe
 * id DF11B72C-D029-49BB-9657-6A267CC1DEA4
 * name car-shift-pattern
 * version: 3.9.97
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/car-shift-pattern.svg
 * tags
 * - Automotive 
 */
export const CarShiftPatternIcon = createSvgIcon(<><path d="M8 5H4V2H8V5M4 22H8V19H4V22M14 2H10V5H14V2M10 22H14V19H10V22M16 2V5H20V2H16M17 11H13V7H11V11H7V7H5V17H7V13H11V17H13V13H19V7H17V11Z" /></>, 'CarShiftPatternIcon');
export default CarShiftPatternIcon